var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeXdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.333,
    height: 52,
    viewBox: "0 0 53.333 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-adobexd",
    "data-name": "Icon simple-adobexd",
    d: "M43.889.45H9.444A9.437,9.437,0,0,0,0,9.894V43.006A9.437,9.437,0,0,0,9.444,52.45H43.889a9.437,9.437,0,0,0,9.444-9.444V9.894A9.437,9.437,0,0,0,43.889.45Zm7.2,41.689a8.051,8.051,0,0,1-8.044,8.089H10.289a8.08,8.08,0,0,1-8.067-8.067V10.739a8.08,8.08,0,0,1,8.067-8.067H43.022a8.067,8.067,0,0,1,8.067,8.067Zm-30-17.356,6.222,11.956c.111.178.044.356-.133.356H23.311a.436.436,0,0,1-.467-.289c-1.422-2.933-2.867-5.867-4.356-9.022h-.044c-1.333,2.978-2.8,6.111-4.222,9.044a.427.427,0,0,1-.4.244H10.156c-.222,0-.244-.178-.133-.311l6.089-11.6L10.222,13.428a.18.18,0,0,1,.133-.311h3.822a.35.35,0,0,1,.4.244c1.4,2.933,2.822,5.956,4.156,8.911h.044c1.289-2.933,2.711-5.978,4.089-8.889.111-.178.178-.289.4-.289h3.578c.178,0,.244.133.133.311ZM28.4,28.406c0-5.178,3.444-9.222,8.911-9.222a9.854,9.854,0,0,1,1.156.044V13.339a.223.223,0,0,1,.222-.222H42.2c.178,0,.222.067.222.178v20.4a15.828,15.828,0,0,0,.111,2.178c0,.133-.044.178-.178.244a13.237,13.237,0,0,1-5.689,1.289C31.844,37.428,28.4,34.45,28.4,28.406Zm10.067-5.689a3.361,3.361,0,0,0-1.289-.222c-2.8,0-4.756,2.156-4.756,5.733,0,4.089,2,5.733,4.511,5.733a4.192,4.192,0,0,0,1.533-.244v-11Z",
    transform: "translate(0 -0.45)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeXdLogo);
export default __webpack_public_path__ + "static/media/adobe-xd-logo.1eab7a29f3d65646581cdb3e19c51dfe.svg";
export { ForwardRef as ReactComponent };